export default "__VITE_ASSET__71976ba9__"